import React from 'react';
import { Persona } from '../../types';

type PersonaAvatarSize = 'sm' | 'md' | 'lg';

interface PersonaAvatarProps {
  persona: Persona;
  size?: PersonaAvatarSize;
  className?: string;
}

const sizeClasses: Record<PersonaAvatarSize, string> = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-16 w-16',
};

const PersonaAvatar: React.FC<PersonaAvatarProps> = ({ persona, size = 'md', className = '' }) => {
  const src =
    persona.avatar_url && persona.avatar_url.trim().length > 0
      ? persona.avatar_url
      : '/default-persona-avatar.svg';

  const sizeClass = sizeClasses[size] || sizeClasses.md;

  return (
    <img
      src={src}
      alt={persona.name}
      className={`inline-block rounded-full object-cover bg-gray-100 ${sizeClass} ${className}`.trim()}
    />
  );
};

export default PersonaAvatar;


